import { useId, useRef } from "react";
import { useTranslation } from "react-i18next";
import useDialogAccessibility from "../../hooks/useDialogAccessibility";

const DeleteCharacterDialog = ({
  character,
  error,
  isDeleting,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const cancelButtonRef = useRef(null);
  const dialogRef = useRef(null);
  const titleId = useId();

  useDialogAccessibility({
    closeDisabled: isDeleting,
    containerRef: dialogRef,
    initialFocusRef: cancelButtonRef,
    isOpen: Boolean(character),
    onClose,
  });

  if (!character) return null;

  const characterName = character.characterName || t("characters.unnamed");

  return (
    <div
      className="character-create-overlay"
      onMouseDown={() => !isDeleting && onClose()}
    >
      <section
        aria-labelledby={titleId}
        aria-modal="true"
        className="character-create-dialog"
        ref={dialogRef}
        role="alertdialog"
        tabIndex="-1"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header>
          <div>
            <p>{t("characters.deleteEyebrow")}</p>
            <h2 id={titleId}>{t("characters.deleteTitle")}</h2>
          </div>
          <button
            aria-label={t("common.close")}
            disabled={isDeleting}
            type="button"
            onClick={onClose}
          >
            ×
          </button>
        </header>

        <p className="character-create-description">
          {t("characters.deleteDescription", { name: characterName })}
        </p>

        {error && <p className="character-create-error" role="alert">{error}</p>}

        <footer>
          <button ref={cancelButtonRef} disabled={isDeleting} type="button" onClick={onClose}>
            {t("common.cancel")}
          </button>
          <button
            className="character-delete-submit"
            disabled={isDeleting}
            type="button"
            onClick={onConfirm}
          >
            {isDeleting ? t("characters.deleting") : t("characters.deleteConfirm")}
          </button>
        </footer>
      </section>
    </div>
  );
};

export default DeleteCharacterDialog;
